export default __webpack_public_path__ + "static/media/ssk.abbe488b.jpg";